/*
 * winerd-age-gate.js — Verificación de mayoría de edad para la vista Winerd.
 * Task #119, fase 1/7.
 *
 * Archivo propio (NO el bundle theme.js) para que sobreviva a recompilaciones
 * del tema por Maestrooo.
 *
 * Persistencia: si el usuario marca "recordar en este dispositivo" -> localStorage
 * (permanente); si no -> sessionStorage (dura solo la pestaña/sesión).
 *
 * El markup lo pone snippets/winerd-age-gate.liquid. Este script hace
 * early-return si no encuentra [data-winerd-age-gate] en el DOM, así que
 * cargarlo en páginas sin age-gate no cuesta nada.
 */
(function () {
  "use strict";

  if (window.__winerdAgeGate) return;
  window.__winerdAgeGate = true;

  var KEY = "winerd_age_confirmed";

  function isConfirmed() {
    try {
      if (window.localStorage && localStorage.getItem(KEY)) return true;
    } catch (e) {}
    try {
      if (window.sessionStorage && sessionStorage.getItem(KEY)) return true;
    } catch (e) {}
    return false;
  }

  function persist(remember) {
    try {
      if (remember && window.localStorage) {
        localStorage.setItem(KEY, "1");
        return;
      }
      if (window.sessionStorage) sessionStorage.setItem(KEY, "1");
    } catch (e) {}
  }

  function init() {
    var gate = document.querySelector("[data-winerd-age-gate]");
    if (!gate) return;

    if (isConfirmed()) {
      gate.hidden = true;
      return;
    }

    gate.hidden = false;
    document.body.classList.add("winerd-age-lock");

    var confirmBtn = gate.querySelector("[data-winerd-age-confirm]");
    var remember = gate.querySelector("[data-winerd-age-remember]");

    if (confirmBtn) {
      confirmBtn.focus();
      confirmBtn.addEventListener("click", function () {
        persist(remember && remember.checked);
        gate.hidden = true;
        document.body.classList.remove("winerd-age-lock");
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
